import {
    Component,
    OnInit,
    Input,
    Output,
    HostBinding,
    EventEmitter,
    ViewEncapsulation
} from '@angular/core';

import { ApiService } from '../../core/upgraded-providers';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-shard-selector',
    templateUrl: './shard-selector.component.pug',
    styleUrls: ['./shard-selector.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class ShardSelectorComponent implements OnInit {
    @HostBinding('class.--ui') _ui = true;
    @HostBinding('hidden') hidden = false;

    _shardsSbj: BehaviorSubject<any[]> = new BehaviorSubject([]);
    public shards$: Observable<any[]> = this._shardsSbj.asObservable()
        .pipe(map((items) => items.map((value) => ({ value, name: value }))));
    @Input() set shards(shards: string[]) {
        this._shardsSbj.next(shards);
    }
    get shards(): string[] {
        return this._shardsSbj.getValue();
    }

    @Input() shard: string;
    @Output() change: EventEmitter<string> = new EventEmitter();

    constructor(
        private _apiService: ApiService
    ) {}

    ngOnInit() {
        this.shards = this._apiService.options.serverData.shards;

        if (this.shards.length <= 1) {
            this.hidden = true;
        }
    }

    onChange(shard) {
        this.change.emit(shard);
    }

}
